import LocalStorageKey from "@/constants/local-storage-key";
import AuthUtils from "@/utils/auth";

const SessionUtils = {
    /**
     * @param {string} name
     * @param  {*} defaultValue
     * @returns {string}
     */
    getCookie(name, defaultValue = null) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length === 2) {
            return parts.pop().split(";").shift();
        }
        return defaultValue;
    },
    /**
     * Get the session max lifetime in seconds.
     *
     * @returns {Number}
     */
    lifetime() {
        return (_.get(App, "state.config.session.lifetime", 1440) - 1) * 60;
    },
    /**
     * Updates the last active time of user.
     */
    updateLastActive() {
        Vue.ls.set(LocalStorageKey.SESSION_LAST_ACTIVE, moment().unix());
    },
    /**
     * Get the moment the user has been last active.
     *
     * @returns {null|moment.Moment}
     */
    lastActive() {
        let last = Vue.ls.get(LocalStorageKey.SESSION_LAST_ACTIVE);
        if (!last) {
            return null;
        }
        return moment.unix(last);
    },
    /**
     * Get the seconds the user has been idle.
     *
     * @returns {null|Number}
     */
    idle() {
        if (!this.lastActive()) {
            return null;
        }
        return moment().diff(this.lastActive(), "second");
    },
    /**
     * Get the remaining session time in seconds.
     *
     * @returns {null|Number}
     */
    remaining() {
        if (!AuthUtils.loggedIn()) {
            return null;
        }
        if (!this.lifetime() || !this.idle()) {
            return null;
        }
        return this.lifetime() - this.idle();
    },
    /**
     * Get the remaining session time in seconds.
     *
     * @returns {null|string}
     */
    formatRemaining() {
        if (!this.remaining()) {
            return null;
        }
        let minutes = Math.floor(this.remaining() / 60);
        let seconds = this.remaining() % 60;
        return `${minutes < 10 ? "0" + minutes : minutes}:${
            seconds < 10 ? "0" + seconds : seconds
        }`;
    },
    /**
     * Check if remember me is enabled for user
     *
     * @returns {boolean}
     */
    remembersUser() {
        return this.getCookie("remember", "0") === "1";
    },
};

export default SessionUtils;
